import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68fb89f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-customer-body" }
const _hoisted_2 = { class: "category-hover-wrapper" }
const _hoisted_3 = { class: "category-text" }
const _hoisted_4 = {
  key: 0,
  class: "category-arrow"
}
const _hoisted_5 = {
  key: 0,
  class: "category-dropdown"
}
const _hoisted_6 = { class: "category-hover-wrapper" }
const _hoisted_7 = { class: "category-text" }
const _hoisted_8 = {
  key: 0,
  class: "category-arrow"
}
const _hoisted_9 = {
  key: 0,
  class: "category-dropdown"
}

import Header from "@/clinic/components/atoms/Grid/header.vue";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";
import RouterConstants from "@/clinic/constants/router.constants";
import { MenuServices } from "@/clinic/services";
import { ApiBaseReqParams, ApiMenuIndexRes, ApiStaffIndexRes, IMenu } from "@/clinic/typings";
import { DEFAULT_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import RouterUtils from "@/common/utils/router.util";
import { get, set } from "@vueuse/core";
import { AxiosResponse } from "axios";
import _ from "lodash";
import { PageState } from "primevue/paginator";
import { inject, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import NumberUtils from "@/clinic/utils/number-utils";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";
import { StaffServices } from "@/clinic/services";
import { IStaff } from "@/clinic/typings";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();

/**
 * クリニックIDを管理するref。
 */
const clinicId = ref(0);
/**
 * ページネーションの先頭位置を管理するref。
 */
const first = ref(0);
/**
 * 1ページあたりの表示件数を管理するref。
 */
const rows = ref(DEFAULT_PAGINATOR_ROWS);
/**
 * 現在のページ番号を管理するref。
 */
const page = ref(0);
/**
 * 検索ワードを管理するref。
 */
const searchTerm = ref("");
/**
 * 上部ページネータの参照。
 */
const pgTop = ref<InstanceType<typeof Paginator> | null>(null);
/**
 * 下部ページネータの参照。
 */
const pgBot = ref<InstanceType<typeof Paginator> | null>(null);
/**
 * 総件数を管理するref。
 */
const totalCount = ref(0);
/**
 * メニュー一覧を管理するref。
 */
const menus = ref<IMenu[]>([]);
/**
 * テーブルカラム定義。
 */
const columns = [
  { field: "id", header: "メニューID" },
  { field: "medical_menu_category_name", header: "カテゴリー" },
  { field: "name", header: "名前" },
  { field: "description", header: "メニュー説明" },
  { field: "time_unit", header: "所要時間" },
  { field: "unit_price", header: "金額" },
  { field: "staff_names", header: "担当スタッフ" },
  { field: "position_number", header: "順番" },
];

const staffsList = ref<IStaff[]>([]);

/**
 * 未提携クリニックかどうかを判定する。
 * @returns 未提携ならtrue
 */
const isUnaffiliated = () => {
  return store.getters["authClient/selectedClinic"].partner == ClinicPartner.Unaffiliated;
};

/**
 * ページネーション用のAPIパラメータを生成する。
 * @returns {Promise<ApiBaseReqParams>} APIリクエストパラメータ
 */
const paginatorParams = async (): Promise<ApiBaseReqParams> => ({
  term: get(searchTerm),
  rows: DEFAULT_PAGINATOR_ROWS,
  page: get(page) + 1, // APIは1ベースのページ番号を期待
  clinic_id: get(await get(clinicId)),
});

/**
 * メニュー一覧をAPIから取得する。
 * @returns Promise<void>
 */
const loadMenus = async (): Promise<void> => {
  try {
    // メニュー一覧APIを呼び出し、データとメタ情報を取得
    const { data } = (await MenuServices.getMenus(
      await paginatorParams()
    )) as unknown as AxiosResponse<ApiMenuIndexRes>;
    const { menus: menusData, meta } = get(data);

    // 各メニューのstaff_idsから、該当するスタッフオブジェクト配列（staffs）を生成
    const menusWithStaffs = menusData.map(menu => ({
      ...menu,
      // staff_idsが未定義の場合は空配列にし、各IDに該当するスタッフを検索
      // filter(Boolean)で見つからなかったID（null/undefined）を除外
      staffs: (menu.staff_ids || []).map(id => staffsList.value.find(staff => staff.id === id)).filter(Boolean),
    }));

    // スタッフ情報付きのメニュー配列をセット
    set(menus, menusWithStaffs);

    // 総件数をセット
    const { total_count } = meta;
    set(totalCount, total_count);
  } catch (error) {
    console.error("メニュー取得エラー:", error);
    // エラーが発生した場合は現在のページを維持し、データは変更しない
  }
};

/**
 * 検索イベントハンドラ。
 * @param event 入力イベント
 * @returns Promise<void>
 */
const onSearch = async ({ currentTarget }: Event): Promise<void> => {
  set(searchTerm, (currentTarget as HTMLInputElement)?.value);
  // 検索時は1ページ目に戻る（APIは0ベースなので0を設定）
  set(page, 0);
  // ページネーターのUI状態もリセット（0ベースなので0を設定）
  set(first, 0);
  await loadMenus();
};

/**
 * ページネーションイベントハンドラ。
 * @param fromId ページネータID
 * @param pageState ページネータの状態
 * @returns Promise<void>
 */
const paging = async (fromId: string, { page: newPage }: PageState): Promise<void> => {
  if (newPage === get(page)) return;

  // ページ番号の範囲チェック
  const totalPages = Math.ceil(get(totalCount) / get(rows));
  if (newPage < 0 || newPage >= totalPages) {
    console.warn(`無効なページ番号: ${newPage}, 総ページ数: ${totalPages}`);
    return;
  }

  set(page, newPage);
  await loadMenus();
};

/**
 * メニュー行クリック時の処理。
 * @param _event クリックイベント
 * @param menu メニュー情報
 * @returns void
 */
const onItemClick = (_event: Event, { id }: IMenu): void => {
  if (isUnaffiliated()) {
    return RouterUtils.goToWithParams(RouterConstants.MENU_EDIT_ROUTER_NAME, { id });
  }
};

/**
 * 新規メニュー作成画面へ遷移する。
 * @returns void
 */
const movetoNewMenu = (): void => RouterUtils.goTo(RouterConstants.MENU_REGISTRATION_ROUTER_NAME);

/**
 * マウント前に初期データを取得する。
 * @returns Promise<void>
 */
onBeforeMount(async () => {
  set(clinicId, await inject("clinicId"));
  await loadStaffs();
  await loadMenus();
});

/**
 * スタッフ一覧をAPIから取得し、staffsListにセットする。
 * @returns {Promise<void>}
 */
const loadStaffs = async () => {
  try {
    // クリニックIDをパラメータとしてセット
    const params = { clinic_id: get(await get(clinicId)) };

    // スタッフ一覧APIを呼び出し
    const { data } = await StaffServices.getStaffs(params);
    const { staffs: staffsData } = get(data) as unknown as ApiStaffIndexRes;
    staffsList.value = staffsData || [];
  } catch (error) {
    console.error("スタッフ取得エラー:", error);
    // エラーが発生しても空配列を設定して処理を続行
    staffsList.value = [];
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, {
      enableSearch: "",
      searchPlaceholder: "名前を入力",
      onNew: movetoNewMenu,
      createButtonLabel: "新規作成",
      onSearch: onSearch,
      enableCreate: isUnaffiliated()
    }, null, 8, ["enableCreate"]),
    _createElementVNode("div", _hoisted_1, [
      (totalCount.value > 0 && totalCount.value > rows.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 0,
            id: "pg-top",
            ref_key: "pgTop",
            ref: pgTop,
            modelValue: first.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((first).value = $event)),
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value
          }, null, 8, ["modelValue", "totalRecords", "rows"]))
        : _createCommentVNode("", true),
      _createVNode(Grid, {
        items: menus.value,
        columns: columns,
        onOnItemClick: onItemClick
      }, {
        unit_price: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(_unref(NumberUtils).formatJPCurrency(parseInt(data.unit_price), "")) + "円", 1)
        ]),
        position_number: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(_unref(_).toNumber(parseInt(data.position_number)).toLocaleString()), 1)
        ]),
        medical_menu_category_name: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["category-selected", { 'category-empty': !(data.categories && data.categories.length > 0) }])
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(data.categories && data.categories.length > 0 ? data.categories[0].name : ""), 1),
              (data.categories && data.categories.length > 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "▼"))
                : _createCommentVNode("", true)
            ], 2),
            (data.categories && data.categories.length > 1)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.categories, (cat) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: cat.id
                    }, _toDisplayString(cat.name), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        staff_names: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["category-selected", { 'category-empty': !(data.staffs && data.staffs.length > 0) }])
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(data.staffs && data.staffs.length > 0 ? data.staffs[0].name_kanji : ""), 1),
              (data.staffs && data.staffs.length > 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "▼"))
                : _createCommentVNode("", true)
            ], 2),
            (data.staffs && data.staffs.length > 1)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.staffs, (staff) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: staff.id
                    }, _toDisplayString(staff.name_kanji), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["items"]),
      (totalCount.value > 0 && totalCount.value > rows.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 1,
            id: "pg-bot",
            ref_key: "pgBot",
            ref: pgBot,
            modelValue: first.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((first).value = $event)),
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value,
            class: "mt-2"
          }, null, 8, ["modelValue", "totalRecords", "rows"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})